angular.module('mtic.components.modules.c3').
directive('c3Module1', function (
  C3_ASSET_URL,
  $log,
  $http,
  mapItemFactory,
  EventManager,
  TeacherDataService,
  $timeout,
  userAccount,
  PlatformService
) {
  return {
    templateUrl: 'template.html',
    scope: {
      moduleMapData: "=moduleMapData",
      onItemClick: '<',
      submodId: '=?',
      agendasList:'=?'
    },
    link: function (scope) {
      if(!scope.submodId){
        scope.submodId = 'm1v2';
      }
      var submod_mapping = {
        m1: {
          backgroundColor: 0x51b357,
          mapName: '',
        },
        m1v2: {
          backgroundColor: 0x51b357,
          mapName: 'm1v2_',
        },
        m34: {
          backgroundColor: 0x00c1df,
          mapName: 'm34_',
        },
        m56: {
          backgroundColor: 0x43BED1,
          mapName: 'm56_',
        },
      }

      scope.isWorkspaceView = TeacherDataService.isTeacherWorkspaceView;
      scope.isTeacher = userAccount.getData().role.isTeacher;
      var thiz = this;
      var doUpdate = false;
      var eventManager = new EventManager('c3Module',scope);
      var canvasDimention;
      //PIXI Rendering Settings
      var isAndroid = navigator.userAgent.match(/Android/i);
      var renderer;
      if(isAndroid){
        renderer = new PIXI.CanvasRenderer(256,256,{
          autoResize: true,
          backgroundColor: submod_mapping[scope.submodId].backgroundColor,
          view: document.getElementById('canvas')
        });
      }else{
        renderer = PIXI.autoDetectRenderer(256, 256, {
          autoResize: true,
          backgroundColor: submod_mapping[scope.submodId].backgroundColor,
          view: document.getElementById('canvas')
        });
      }

      var sidepanel_width = 0;
      if(scope.isTeacher){
        let sidepanel = document.getElementById('teacher_sidepanel');
        sidepanel_width = TeacherDataService.inTeacherAgendaView ? 60 : sidepanel.offsetWidth;
        if(!TeacherDataService.inTeacherAgendaView && TeacherDataService.isWorkspaceView){
          sidepanel_width += -30;
        }
      }

      canvasDimention = {
        width: window.innerWidth - sidepanel_width - 180,
        height: window.innerHeight - 50,
      }
      //REMOVE THIS ONCE AGENDA
      // if(!scope.isTeacher){
      //   canvasDimention.width = window.innerWidth;
      // }
      //end
      // var workspaceAdjustingScale = {
      //   x:0.7,
      //   y:0.7
      // }

      var scale = canvasDimention.width/window.innerWidth;

      $log.log('SETTING IMAGE DIMENSIONS : ' , canvasDimention.width, window.innerWidth, scale)
      // if(scope.isWorkspaceView && window.screen.width < 1200){
      //   scale = 0.4;
      // }else if(scope.isWorkspaceView && window.screen.width < 1400){
      //   scale = 0.5;
      // }
      var stage = new PIXI.Container();
      var graphics = new PIXI.Graphics();
      var sprite;
      var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));
      stage.interactive = true;
      stage.addChild(graphics);
      thiz.renderer = renderer;
      //console.log('stage m1 : ', stage.children)

      //Handles the intro animation/fade in
      var cloud_man = (function CloudManager() {
        var progress = 0;
        var randomMod = Math.random();
        var clouds = [];
        var overlay = new PIXI.Graphics();

        overlay.beginFill(0x0b2732);
        overlay.drawRect(0, 0, 100, 100);
        overlay.endFill();

        var overlay_sprite = new PIXI.Sprite(overlay.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST));
        // overlay_sprite.position.x = overlay_sprite.width/2;
        // overlay_sprite.position.y = overlay_sprite.height/2;
        // $log.log("width-height",overlay_sprite.width,overlay_sprite.height);
        return {
          overlay_sprite: overlay_sprite,
          update: function () {
            progress = Math.min(progress + 1, 100);
            overlay_sprite.alpha = (100 - progress) / 100.0;
          },
          onResize: function (width, height) {
            overlay_sprite.width = width;
            overlay_sprite.height = height;
          }
        }

      })();
      stage.addChild(cloud_man.overlay_sprite);
      var items = [];

      //Object that tracks intertial click and drag panning around the screen
      var drag_info = {
        dragging: false,
        velocity: {
          x: 0,
          y: 0
        },
        last_mouse_pos: {
          x: 0,
          y: 0,
        },
        start_drag_mouse_pos: {
          x: 0,
          y: 0
        },
        start_drag_pos: {
          x: 0,
          y: 0
        }
      }

      //On a click, pull the pixel color at the mouse position from the gl render and create some particles
      var makeGrass = function () {
        renderer.render(stage);
        var gl = renderer.gl;
        var pixelValues = new Uint8Array(4);
        if(gl)
        {
          gl.readPixels(renderer.plugins.interaction.eventData.data.global.x, renderer.height - renderer.plugins.interaction.eventData.data.global.y, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixelValues);
        }
        for (var i = 0; i < 10; i++) {
          /*jshint bitwise: false*/
          var hex = Math.min(Math.max(0, pixelValues[0] - 15 + Math.random() * 50), 255) << 16 |
          Math.min(Math.max(0, pixelValues[1] - 15 + Math.random() * 50), 255) << 8 |
          Math.min(Math.max(0, pixelValues[2] - 15 + Math.random() * 50), 255);
          /*jshint bitwise: true*/
          var particle = new PIXI.Sprite(thiz.grass_tex);
          particle.tint = hex;
          thiz.particle_container.addChild(particle);
          particle.x = (drag_info.last_mouse_pos.x - sprite.x - Math.random() * 5) / scale;
          particle.y = (drag_info.last_mouse_pos.y - sprite.y - Math.random() * 5) / scale;
          particle.vel = {
            x: Math.random() * 5 - 2.5,
            y: -Math.random() * 4
          }
          particle.anchor.set(0.5, 0.5);
          particle.scale.set(1.5 + Math.random(), 1.5 + Math.random());
        }
      }

      //This loops to control things that should update every frame
      var update = function () {
        if (!doUpdate || !renderer) {
          return;
        }
        //update the fade in animation
        cloud_man.update();

        //Update the particle system
        for (var i = 0; i < thiz.particle_container.children.length; i++) {
          var child = thiz.particle_container.children[i];
          child.vel.y += 0.15;
          child.vel.x *= 0.95;
          child.vel.y *= 0.95;
          child.transform.position.y += child.vel.y;
          child.transform.position.x += child.vel.x;

          child.transform.scale.x *= 0.8 + Math.random() / 5; //0.93;
          child.transform.scale.y *= 0.8 + Math.random() / 5; //0.93;

          if (child.transform.scale.x < 0.05) {
            thiz.particle_container.removeChild(child);
            i--;
          }
        }

        //mouse drag map panning
        if (drag_info.dragging && _TOUCHED_POINTS.length < 2) {
          drag_info.velocity = {
            x: drag_info.velocity.x * 0.954,
            y: drag_info.velocity.y * 0.954
          };

        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;

          sprite.position.x -= drag_info.velocity.x;
          sprite.position.y -= drag_info.velocity.y;
        }

        //Ater dragging, center the map if it is smaller than the window dimensions or clamp the position if the map is larger than the window dimensions
        // if (window.innerWidth > sprite.width + 200) {
        //   sprite.position.x = window.innerWidth / 2 - sprite.width / 2;
        //   if(scope.isTeacher){
        //     sprite.position.x -= 100;
        //   }
        // } else {
          // sprite.position.x = Math.max((window.innerWidth - sprite.width - 100), Math.min(+100, sprite.position.x));
        // }

        if (sprite && window.innerHeight > sprite.height + 200) {
          sprite.position.y = window.innerHeight / 2 - sprite.height / 2;
        } else if(sprite){
          sprite.position.y = Math.max((window.innerHeight - sprite.height - 100), Math.min(100, sprite.position.y));
        }

        if(sprite){
          sprite.x = Math.max(Math.min(renderer.width / 2 - sprite.width / 2 + 250, sprite.position.x), renderer.width / 2 - sprite.width / 2 - 250)// - 200/scale;
        }
        //render the map (with PIXI) and request another update loop call from the canvas context
        renderer.render(stage);
        requestAnimationFrame(update);

        if (window.DEBUG_TOUCH){ $log.log('c3m1 update ; ', JSON.stringify(drag_info)); }

      };


      thiz.onResize = function (sidepanel_expanded) {
        var _canvasEl = document.getElementById('canvas')
        if (!_canvasEl) {
          return;
        }
        var sidepanel_width = TeacherDataService.sidepanelStatus ? 260:60;
        var canv_width;
        if(!TeacherDataService.isTeacherWorkspaceView && !TeacherDataService.inTeacherAgendaView){
          if(sidepanel_expanded === true || sidepanel_expanded === false){
            sidepanel_width = sidepanel_expanded ? 140 : -200;
          }else{
            sidepanel_width = 0;
          }
          canv_width =  _canvasEl.parentElement.parentElement.offsetWidth - sidepanel_width;
        }else{
          var middleview = document.getElementById('agenda_middleview');
          if(middleview){
            sidepanel_width += 300
          }
          if(!TeacherDataService.inTeacherAgendaView){
            sidepanel_width += -30;
          }
          canv_width = window.innerWidth - 370 - sidepanel_width;
        }

        canvasDimention = {
          width: canv_width,
          height: window.innerHeight - 35
        }

        scale = canvasDimention.width/window.innerWidth;
        scale = isMobile ? scale * 0.75 : scale;
        if(thiz.sprite && sidepanel_expanded !== true && sidepanel_expanded !== false ){
          thiz.sprite.scale.set(scale, scale);
        }

      //REMOVE THIS ONCE AGENDA
      // if(!scope.isTeacher){
      //   canvasDimention.width = window.innerWidth;
      // }
      //end

        if (_canvasEl && canvasDimention){

          _canvasEl.width = canvasDimention.width;
          _canvasEl.height = canvasDimention.height;

          renderer.resize(canvasDimention.width, canvasDimention.height);
          cloud_man.onResize(canvasDimention.width, canvasDimention.height);
          // cloud_man.onResize(canvasDimention.width+((1-workspaceAdjustingScale.x)*canvasDimention.width), canvasDimention.height+((1-workspaceAdjustingScale.y)*canvasDimention.height));
          // $log.log("resized-width-height",canvasDimention.width,canvasDimention.height);
        }

      };


      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        //this is what runs to initialize the map
        if (!PIXI_Load_Cache || !PIXI.loader.resources[C3_ASSET_URL + submod_mapping[scope.submodId].mapName + "map.png"]) {
          PIXI.loader.reset();
          PIXI.loader
          .add([
            C3_ASSET_URL + "map.png",
            C3_ASSET_URL + "m1v2_map.png",
            C3_ASSET_URL + "m34_map.png",
            C3_ASSET_URL + "m56_map.png",
            C3_ASSET_URL + "star.png",
            C3_ASSET_URL + "item_blue_0.png",
            C3_ASSET_URL + "item_blue_1.png",
            C3_ASSET_URL + "item_red_0.png",
            C3_ASSET_URL + "item_red_1.png",
            C3_ASSET_URL + "item_red_2.png",
            C3_ASSET_URL + "item_red_3.png",
            C3_ASSET_URL + "item_black_0.png",
            C3_ASSET_URL + "item_black_1.png",
            C3_ASSET_URL + "item_black_2.png",
            C3_ASSET_URL + "item_black_3.png",
            C3_ASSET_URL + "item_blue_locked.png",
            C3_ASSET_URL + "item_red_locked.png",
            C3_ASSET_URL + "item_black_locked.png",
            C3_ASSET_URL + "item_af_locked.png",
            C3_ASSET_URL + "item_af.png",
            C3_ASSET_URL + "item_test.png",
            C3_ASSET_URL + "assessment.png",
            C3_ASSET_URL + "assessment_complete.png",
            C3_ASSET_URL + "item_test_locked.png"
          ])
          .load(function () {
            PIXI_Load_Cache = true;
            $timeout(()=>{
              init(moduleMapData.resources);
            })
          })
        } else {
            $timeout(()=>{
              init(moduleMapData.resources);
            })
        }
      });


      var _TOUCHED_POINTS = []
      var init = function (moduleMapData) {
        $log.debug('[[c3Module]] INIT', moduleMapData)
        var combinedResourceMap = {};
        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
        });
        if (Object.keys(combinedResourceMap).length !== moduleMapData.length) {
          throw "some resourceMap slugs are not unique!"
        }

        sprite = new PIXI.Sprite(PIXI.loader.resources[C3_ASSET_URL + submod_mapping[scope.submodId].mapName + "map.png"].texture);
        sprite.interactive = true;

        // if(TeacherDataService.isTeacherWorkspaceView)
        // {
          // sprite.y =  sprite.height / 2;
        // }else{
          // $log.log('sprite data : ', renderer.width, sprite.width)
          sprite.x = renderer.width / 2 - sprite.width / 2 + 200/scale;
          sprite.y = renderer.height / 2 - sprite.height / 2;
        // }

        stage.addChildAt(sprite, 0);
        thiz.sprite = sprite;

        thiz.sprite.scale.set(scale, scale);

        thiz.particle_container = new PIXI.Sprite();
        sprite.addChild(thiz.particle_container);
        var grass_graphic = new PIXI.Graphics();
        grass_graphic.beginFill(0xFFFFFF);
        grass_graphic.drawCircle(5, 5, 5);
        grass_graphic.endFill();
        thiz.grass_tex = grass_graphic.generateCanvasTexture(PIXI.SCALE_MODES.NEAREST);


        stage.on('pointerdown', function (e) {
          var e_o = e.data.originalEvent;
          _TOUCHED_POINTS.push({ pointer_id: e_o.pointerId, x:e_o.pageX, y:e_o.pageY});

          drag_info.dragging = true;

          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: sprite.x,
            y: sprite.y
          };
          drag_info.start_drag_mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };

          if (window.DEBUG_TOUCH){ $log.log('c3m1 pointerdown ; ', JSON.stringify(drag_info)); }

        });

        stage.on('pointermove', function(e) {
          if (!drag_info.dragging) {
            return;
          }

          var mouse_pos = {
            x: e.data.global.x,
            y: e.data.global.y
          }
          //Move the map based on the mouse position
          sprite.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          sprite.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };
        })


        stage.on('pointerup', function (e) {
          drag_info.dragging = false;
          if (window.DEBUG_TOUCH){ $log.log('c3m1 pointerup ; ', JSON.stringify(drag_info), e); }
          if (Math.abs(drag_info.start_drag_pos.x - sprite.x) < 5 && Math.abs(drag_info.start_drag_pos.y - sprite.y) < 5) {
            makeGrass();
          }

          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });
        stage.on('pointerout', function (e) {
          drag_info.dragging = false;
          var e_o = e.data.originalEvent;
          var index = _TOUCHED_POINTS.findIndex(function(point, index) {
            if(point.pointer_id === e.pointerId){
              return true;
            }
          });
          _TOUCHED_POINTS.splice(index, 1);
        });

        _.each(combinedResourceMap, function (resource) {
          if (!resource.display.position) {
            return;
          }
          var displayItem;
          if (TeacherDataService.isTeacherModuleView){
            resource.locked = false;
          }
          items.push(displayItem = new mapItemFactory.createMapItem(resource,scope.onItemClick, eventManager));
          if (resource.slug === 'mtic_c3_m1_assessment'){
            if (resource.studentWork !== null) {
              if (resource.complete) {
                // $log.debug(resource.slug + " completed ");
                displayItem.addCompleteStar();
              }
            }
          }
          displayItem.sprite.position.x -= 20;
          displayItem.sprite.position.y -= 15;
          sprite.addChild(displayItem.sprite);
        })
        _.forEach(items, function (item) {
          if (!item.locked || item.unlockedByAgenda) {
            item.unlock();
          }
        })

        if(TeacherDataService.inTeacherAgendaView){
          eventManager.broadcast('agenda:request:selected');
        }

        if(scope.agendasList && scope.agendasList.length > 0){
          scope.agendasList.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })
        }
        doUpdate = true;
        update();
      };

      eventManager.listen('agenda:respond:selected', function(e, data){
        // $log.log('GOT AGENDA RESPONSE : ' , data)
        items.forEach(function(cur){
          cur.hideAgendaHighlight();
        })
        data.forEach(function(item){
          var get_item = getItemBySlug(item.slug);
          if(get_item){
            get_item.showAgendaHighlight(true);
          }
        })
      })

      eventManager.listen('module:change:meta', function(e, slug) {
        eventManager.broadcast("close:current:module",slug);
      });


      renderer.render(stage);
      window.addEventListener("resize", thiz.onResize);
      //var isExpanded = TeacherDataService.inTeacherAgendaView || isMobile ? false : null;
      thiz.onResize();

      $timeout(function(){
        var _canvasEl = document.getElementById('canvas');
        if(_canvasEl){
          _canvasEl.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
          _canvasEl.addEventListener('mousewheel', handleScroll, false); // for everyone else
        }
      }, 1000)

      eventManager.listen('destroy-c3-map', function(){
        destroy_this();
      })

      var currentHighlighted;
      eventManager.listen('module:select:resource', function(e, data) {
        // $log.log('got event module:select:resource ', data)
        var scopeResource = getResourceBySlug(data.slug);
        if (scopeResource === null){
          eventManager.broadcast('module:dismiss:focus')
          eventManager.broadcast('module:change:metaToSub', data);
          return;
        }
        if(scope.onItemClick){
          // $log.log('from item click listen')
          var item = getItemBySlug(data.slug);
          scope.onItemClick(scopeResource,item, data);
        }else{
          if(currentHighlighted){
            currentHighlighted.hideAgendaHighlight();
          }
          var get_item = getItemBySlug(data.slug);
          if(get_item){
            get_item.showAgendaHighlight(true);
            currentHighlighted = get_item;
          }
        }

        $timeout(function(){
          thiz.onResize();
        }, 100)
      })

      var getItemBySlug = function(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      }

      var getItemById = function(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      }

      var getResourceBySlug = function(slug)
      {
        var i, n;
        for (n = 0; n < scope.moduleMapData.children.length; n ++)
        {
            if (scope.moduleMapData.children[n].slug === slug)
            {
              return scope.moduleMapData.children[n];
            }

        }
        return null;
      }

      eventManager.listen('sidepanel:toggled', function(e, val){
        if(!PlatformService.isPhonePortrait()){
          thiz.onResize(val);
        }
      })

      // eventManager.listen('module:center:resource', function(e, data) {
      //   $log.log('c3, do you get this : ', data)
      //   //focus_item = getItemBySlug(data.slug);
      // })

      eventManager.listen('hide_item_selection_highlight', function(e, resource){
        // $log.log('got hide ? ', resource)
        var item = getItemBySlug(resource.slug);
        if(item){
          item.hideAgendaHighlight(true);
        }
      })

      eventManager.listen('toggle_item_selection_highlight', function(e, slug){
        // $log.log('got toggle_item_selection_highlight ? ', slug)
        var item = getItemBySlug(slug);
        item.showAgendaHighlight();
      })

      eventManager.listen('moduleview:agenda:loaded', function(e, data){
        if (data.length > 0)
        {
          scope.agendasList = data;
          data.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })

        }
      });
      scope.$watch('agendasList', function(data){
        if(data){
          data.forEach(function(agenda){
            if(agenda.force_unlock){
              agenda.resources.forEach(function(item){
                unlockpath(item);
              })
            }
          })
        }
      })
      function unlockpath(item_id, use_slug){
        items.forEach(function(resource){
          if(resource.id === item_id || (use_slug && item_id === resource.slug)){
            resource.unlock();
            resource.unlockedByAgenda = true;
            if(resource.unlocked_by.length > 0){
              resource.unlocked_by.forEach(function(higher_resource){
                unlockpath(higher_resource, true);
              })
            }
          }
        })
      }


      eventManager.listen('offline-post-call-resolved', function(){
        destroy_this(true)
        eventManager.broadcast('refresh:current:tab');
        eventManager.broadcast('student:cycle:open');
      });
      function destroy_this(clear_cache){
        doUpdate = false;
        PIXI_Load_Cache = false;
        var _canvasEl = document.getElementById('canvas')
        _canvasEl.removeEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        _canvasEl.removeEventListener('mousewheel', handleScroll, false); // for everyone else
        window.removeEventListener("resize", thiz.onResize);

        if(stage){
          stage.removeChildren();
        }
        if(clear_cache){
          for(var texture in PIXI.TextureCache){
            var tmp = PIXI.Texture.removeTextureFromCache(texture);
            tmp.destroy(true);
          }
        }
        if(renderer){
          renderer.destroy(true);
        }
      }

      scope.$on('$destroy', function() {
        destroy_this();
      });

      var zooming = false;
      scope.zoom_function = function(val){
        handleScroll({detail: val, preventDefault: ()=>{}})
        zooming = true;
        $timeout(function(){
          zooming = false
        }, 10)
      }
      var handleScroll = function(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.0, scale + direction / 15), 0.25);
        var diff = scale - start_scale;

        thiz.sprite.scale.set(scale, scale);

        evt.preventDefault();
        return false;
      };
    }
  }
});

var PIXI_Load_Cache;
